import { useEffect } from 'react';
import ReactGA from 'react-ga4';

const usePageTracking = (location, consentGiven) => {
  useEffect(() => {
    if (consentGiven) {
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
  }, [location, consentGiven]);
};

export default usePageTracking;
